import { render, staticRenderFns } from "./PassReset.vue?vue&type=template&id=62b1389d&scoped=true"
import script from "./PassReset.vue?vue&type=script&lang=js"
export * from "./PassReset.vue?vue&type=script&lang=js"
import style0 from "./PassReset.vue?vue&type=style&index=0&id=62b1389d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b1389d",
  null
  
)

export default component.exports